import { PricingSettings } from '../../../models/profit/profit.model';
import { useGet } from '../../useApi';

// GET /admin/pricing-settings. Saving goes through PricingCard's review step
// (PUT with a reason and a fresh passkey check, pricing spec P9).
const usePricingSettings = () => {
  const { data, loading, fetch, setData } = useGet<PricingSettings>('Failed to load the pricing settings');
  return {
    settings: data,
    loading,
    setSettings: setData,
    fetchSettings: () => fetch('api/v1/admin/pricing-settings'),
  };
};

export default usePricingSettings;
